<template>
  <div>
    <!-- Barre d'outils avec onglets -->
    <v-toolbar dense tabs color="primary darken-2" dark class="page_title">
      <v-toolbar-title class="pa-0 pr-0 mt-1">
        <v-layout row>
          <v-flex xs10 sm11 text-xs-left>
            <!-- Flèche retour en JS -->
            <v-btn flat fab small class="pa-0" @click="goBack">
              <i class="fas fa-arrow-left headline"></i>
            </v-btn>
            Reseller Marketplace
            <v-btn icon small class="ml-2" @click="openGuide" title="How it works">
              <v-icon small>mdi-help-circle-outline</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs2 sm1 text-xs-right>
            <!-- Croix vers business dashboard -->
            <v-btn flat fab small class="pa-0" @click="goToDashboard">
              <i class="fas fa-close headline"></i>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Onglets masqués si pas encore reseller -->
      <v-tabs
        v-if="isReseller"
        v-model="tabs"
        color="transparent"
        slider-color="white"
        slot="extension"
      >
        <v-tab v-for="tabsItem in resellerTabs" :key="tabsItem.id" :to="tabsItem.link">
          <span class="pl-1 pr-1">{{ tabsItem.title }}</span>
        </v-tab>
      </v-tabs>

      <!-- Message si pas encore approuvé -->
      <div v-else slot="extension" class="d-flex align-center justify-center px-3 py-2">
        <small class="grey--text text--lighten-2 mr-3">
          <v-icon small class="mr-1">info</v-icon> Waiting for reseller approval
        </small>
        <v-btn small outlined pill dark color="white" :to="applyLink" class="text-none">
          Become a Reseller
        </v-btn>
      </div>
    </v-toolbar>

    <!-- Contenu dynamique -->
    <v-container fluid>
      <v-layout row>
        <v-flex xs12>
          <v-slide-y-transition mode="out-in">
            <router-view />
          </v-slide-y-transition>
        </v-flex>
      </v-layout>
    </v-container>

    <GuidePopup ref="guide" role="reseller" :auto-show="isReseller" />
  </div>
</template>

<script>
import axios from 'axios'
import GuidePopup from '@/components/GuidePopup.vue'

export default {
  name: 'ResellerLayout',

  components: { GuidePopup },

  data() {
    return {
      tabs: null,
      isReseller: false,
      // Onglets spécifiques au reseller
      resellerTabs: [
        {
          id: 1,
          title: "Dashboard",
          link: "/business-account/market_place/reseller/dashboard",
        },
        {
          id: 2,
          title: "Products",
          link: "/business-account/market_place/reseller/products",
        }
      ],
      applyLink: "/business-account/market_place/reseller/apply",
    };
  },

  mounted() {
    document.title = "Reseller Marketplace";
    this.checkResellerStatus();
  },

  methods: {
    async checkResellerStatus() {
      try {
        const response = await axios.get('/api/v1/market_place/reseller/check-status/')
        this.isReseller = response.data.is_reseller === true
      } catch (error) {
        console.error('Error checking reseller status:', error)
        this.isReseller = false
      }
    },

    goBack() {
      if (window.history.length > 2) {
        this.$router.back()
      } else {
        this.$router.push('/business-account/market_place/reseller/dashboard')
      }
    },

    goToDashboard() {
      this.$router.push('/business-account/dashboard')
    },

    openGuide() {
      if (this.$refs.guide) {
        this.$refs.guide.open()
      }
    }
  }
};
</script>

<style scoped>
.page_title {
  position: sticky;
  top: 0;
  z-index: 5;
}
</style>